import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import type { EntityCellProps } from '../../../../model/index.tsx';
import { getPopularity } from '../../../../state/selectors/filters/index.tsx';
import type { State } from '../../../../state/types.tsx';
import Popularity from './view.tsx';

const mapStateToProps = () => (state: State, ownProps: EntityCellProps) => ({
	popularity: getPopularity(state, ownProps.id),
});

export default connect(mapStateToProps, {})(Popularity);
